import type { ButtonHTMLAttributes } from "react";
import React from "react";
import "./Button.scss";

export type ButtonProps = {
  className?: string;
  children: React.ReactNode;
  // Optional: a `type="submit"` button can rely on the parent form's onSubmit.
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({ className, children, onClick, ...rest }: ButtonProps) => {
  return (
    <button className={`button ${className}`} onClick={onClick} {...rest}>
      {children}
    </button>
  );
};

export default Button;
